/**
 * A panel width the user drags, kept within its limits and remembered in this browser under `key`.
 * Storage can be missing or blocked (a private window): the width then just lasts for the session.
 */
export function useResizableWidth(key: string, limits: { initial: number, max: number, min: number }) {
  const clamp = (width: number) => Math.round(Math.min(limits.max, Math.max(limits.min, width)))

  function read() {
    try {
      const stored = Number(localStorage.getItem(key))
      return stored > 0 ? clamp(stored) : limits.initial
    }
    catch {
      return limits.initial
    }
  }

  const current = ref(read())
  const width = computed({
    get: () => current.value,
    set: (next: number) => {
      current.value = clamp(next)
      try {
        localStorage.setItem(key, String(current.value))
      }
      catch {}
    },
  })

  function reset() {
    width.value = limits.initial
  }

  return { reset, width }
}
